import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link, useSearchParams } from 'react-router-dom';
import { formatDate, searchQuery } from '../../actions/global-actions';
import Paginator from '../../components/paginator/paginator';
import { deleteTask, getTasks, updateTask } from '../../actions/tasks-actions';
import { BsFillTrashFill, BsSearch, BsArrowUp, BsArrowDown, BsFillEyeSlashFill } from "react-icons/bs";
import { isNumeric, itemsPerPage } from '../../actions/global-actions-data';
import DatePicker from 'react-date-picker';
import { taskStatus } from './edit-task';

const colors = [
    '#91dcff',
    '#e9ab3b',
    '#146d80',
    '#c0a1e1',
    '#7d9b00',
];

function TasksList(){
    const currentLink = "/tareas";
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [tasks, setTasks] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [showContainer, setShowContainer] = useState(false);
    const [isFirstTime, setIsFirstTime] = useState(true);

    const setSkipValue = () => {
        let page = searchParams.get('page') || 0;
        if (!isNumeric(page)) return 0;
        if (parseInt(page) < 1) return 0;
        page = (parseInt(page)-1) * itemsPerPage;
        return page;
    }

    const [skip, setSkip] = useState(setSkipValue());

    const setParamValue = (name) => {
        if (name === 'date' || name === 'endDate') return searchParams.get(name)?new Date(searchParams.get(name)):'';
        //console.log(name, searchParams.get(name));
        return searchParams.get(name) || '';
    }

    const [isSearched, setIsSearched] = useState(false);

    const [form, setForm] = useState({
        legalCaseID: setParamValue('legalCaseID'),
        legalCaseText: setParamValue('legalCaseText'),
        date: setParamValue('date'),
        endDate: setParamValue('endDate'),
        attorneyID: setParamValue('attorneyID'),
        attorneyText: setParamValue('attorneyText'),
        task: setParamValue('task'),
        taskStatus: setParamValue('taskStatus'),
        visibility: setParamValue('visibility'),
    });

    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    const [dropdown, setDropdown] = useState({
        show: false,
        value: '',
        data: []
    })
    
    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            //console.log('d', data);
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
                return;
            }

            let usersColors = new Map();
            let colorIndex = 0;

            data.data.map( task => {
                // Asignar color al usuario
                if (!usersColors.get(task.personInCharge._id) && task.personInCharge._id !== user._id){
                    if (colorIndex === colors.length) {
                        colorIndex = 0;
                    }
                    usersColors.set(task.personInCharge._id, colors[colorIndex]);
                    task.backgroundColor = colors[colorIndex];
                    colorIndex++;
                }

                if(usersColors.get(task.personInCharge._id)) {
                    task.backgroundColor = usersColors.get(task.personInCharge._id);
                }
                
                task.formattedDate = new Date(task.date);
                if (task.personInCharge._id === user._id) {
                    task.backgroundColor = '#8f8377';

                    let currentDate = new Date();
                    let taskDate = new Date(task.date);
                    let greater = currentDate.getTime() > taskDate.getTime();

                    if (task.status !== 'Terminada' && greater) {
                        Swal.fire({
                            title:"¡Alerta!",
                            confirmButtonColor:"#76b4ff",
                            text: `${user.firstName}, tienes tareas asignadas vencidas`
                        });
                    }

                    if (task.status === 'Sin iniciar' && !greater) {
                        Swal.fire({
                            title:"¡Alerta!",
                            confirmButtonColor:"#76b4ff",
                            text: `${user.firstName}, tienes tareas asignadas pendientes por iniciar`
                        });
                    }
                }
                task.caseText = "";
                if (task.legalCaseID) {
                    task.caseText = task.legalCaseID.filingNumber;
                }
                return task;
            });
            //console.log('d',data.data);

            //data.data.sort((a, b) => a.formattedDate - b.formattedDate);

            setTasks(data.data);

            setPaginatorData({
                ...paginatorData,
                ...response.headers,
            })
        }

        const setIsSearchedValue = () => {
            let params = Object.fromEntries([...searchParams]);
            delete params.page;
            if (Object.keys(params).length>0) {
                setShowContainer(true);
                setIsSearched(true);
            }
        }

        if (loadData) {
            setLoadData(false);
            setTasks([]);

            if (user.userType === "Administrador") {
                dispatch( getTasks( form, skip, getFunction, user.token ) );
                if (isFirstTime) {
                    setIsFirstTime(false);
                    setIsSearchedValue();
                }
                return;
            }

            let params = { status: { '$ne': 'Terminada' } }
            dispatch( getTasks( params, skip, getFunction, user.token ) );
        }
    }, [loadData, dispatch, user, form, skip, paginatorData, isFirstTime, searchParams ]);

    const toggleContainer = () => {
        setShowContainer(!showContainer)
    }

    const handleDateChange = ( name, date ) => {
        if (!date) {
            setForm({
                ...form,
                [name] :  ''
            });
            return;
        }
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleSearchChange = (option, event) => {
        if (event.target.value.length > 2) {
            setForm({
                ...form,
                [event.target.name] :  event.target.value
            });
            if (option === 1) {
                let param = { filingNumber: event.target.value }
                dispatch( searchQuery( event.target.id, param, responseFunction, user.token ) );
                return;
            }
            dispatch( searchQuery( event.target.id, event.target.value, responseFunction, user.token ) );
            return;
        }
        if (option === 1) {
            setForm({
                ...form,
                [event.target.name] :  event.target.value,
                legalCaseID: ''
            });
        } else {
            setForm({
                ...form,
                [event.target.name] :  event.target.value,
                attorneyID: ''
            });
        }
        setDropdown({ show: false, value: '', data: [] });
    }

    const responseFunction = ( link, data ) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data);
            setDropdown({ show: true, value: link, data: data.data });
        }
    }

    const setLegalCaseData = ( data ) => {
        setForm({
            ...form,
            legalCaseID: data._id,
            legalCaseText: `${data.filingNumber}`,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const setAttorneyData = ( data ) => {
        setForm({
            ...form,
            attorneyID: data._id,
            attorneyText: `${data.firstName} ${data.lastName} ${data.documentType} ${data.document} TP: ${data.professionalCard}`,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const deleteSearch = () => {
        setForm({
            legalCaseID: '',
            legalCaseText: '',
            date: '',
            endDate: '',
            attorneyID: '',
            attorneyText: '',
            task: '',
            taskStatus: '',
            visibility: '',
        })
        setSearchParams({});
        stockPaginator();
        setIsSearched(false);
        setLoadData(true);
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    const handleOnClick = (option, task) => {
        let message = option===1?
            `¿Realmente desea eliminar la tarea: ${task.task}?, ¡tenga en cuenta que esta opción NO SE PUEDE DESHACER!`
            :
            `¿Realmente desea ${task.visibility?'ocultar':'mostrar'} la tarea: ${task.task}?`;
        if (window.confirm(message)) {
            if( option === 1 ){
                dispatch( deleteTask( task._id, updateFunction, user.token) );
                return;
            }
            task.visibility = !task.visibility;
            dispatch( updateTask( task, updateFunction, user.token) );
        }
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data.data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: data.data.message?data.data.message:"Tarea actualizada con éxito"
            });
            setLoadData(true);
        }
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] !== '' && form[field] ) {
                    return false
                }
            }
        }
        return true
    }

    const searchFunction = () => {
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar algún campo para continuar",
            });
            return;
        } else {
            setSearchParams(form);
            stockPaginator();
            setIsSearched(true);
            setLoadData(true);
        }
    }

    useEffect(() => {
        //console.log(form)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Tareas</h1>
                {user.userType === 'Administrador' &&
                    <>
                        <div onClick={toggleContainer} style={{ width: 'fit-content', cursor: 'pointer'}}>
                            <h4 className="w-100 my-2 d-flex"> Búsqueda
                                {showContainer?
                                    <BsArrowUp className="arrow-icon"/>
                                :
                                    <BsArrowDown className="arrow-icon"/>
                                }
                            </h4>
                        </div>
                        {showContainer &&
                            <div className="w-100 d-flex flex-wrap">
                                <span className='w-100 m-2'><b>Fecha de vencimiento: </b><i>Para buscar una tarea de una fecha específica solo ponga la fecha de inicio</i></span>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field">Fecha inicio</label>
                                    <DatePicker
                                        value={ form.date }
                                        dayAriaLabel={"Día"}
                                        dayPlaceholder={"dd"}
                                        monthAriaLabel={"Mes"}
                                        monthPlaceholder={"mm"}
                                        yearAriaLabel={"Año"}
                                        yearPlaceholder={"yyyy"}
                                        name={"date"}
                                        onChange={ (date)=>handleDateChange( 'date', date ) }
                                        dateFormat="MM/dd/yyyy"
                                    />
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field">Fecha fin</label>
                                    <DatePicker
                                        value={ form.endDate }
                                        dayAriaLabel={"Día"}
                                        dayPlaceholder={"dd"}
                                        monthAriaLabel={"Mes"}
                                        monthPlaceholder={"mm"}
                                        yearAriaLabel={"Año"}
                                        yearPlaceholder={"yyyy"}
                                        name={"date"}
                                        onChange={ (date)=>handleDateChange( 'endDate', date ) }
                                        dateFormat="MM/dd/yyyy"
                                    />
                                </div>
                                <div className="d-flex flex-column w-25 field position-relative">
                                    <label className="label-field" htmlFor="legal-case">Radicado</label>
                                    <input type="text" className="input-field" id="legal-case" name="legalCaseText" autoComplete="off" placeholder="No de radicado" onChange={(e)=>handleSearchChange(1,e)} value={form.legalCaseText}></input>
                                    <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'legal-case') ? "active" : ""}`}>
                                        { dropdown.data.length > 0 ?
                                            dropdown.data.map((caseItem, index) => (
                                                <div key={index} className="dropdown-item-container" onClick={() => setLegalCaseData(caseItem)}>{caseItem.filingNumber}</div>
                                            ))
                                        :
                                            <span className="dropdown-message-item">Sin resultados  
                                                { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/casos/nuevo"}>, ¿crear?</a> : null}                        
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="d-flex flex-column w-25 field position-relative">
                                    <label className="label-field" htmlFor="user">Responsable</label>
                                    <input id="user" name="attorneyText" type="text" autoComplete='off' className="input-field"  placeholder="Nombre, apellido o documento" onChange={(e)=>handleSearchChange(2,e)} value={form.attorneyText}></input>
                                    <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'user') ? "active" : ""}`}>
                                        { dropdown.data.length > 0 ?
                                            dropdown.data.map((option, index) => (
                                                <div key={index} className="dropdown-item-container" onClick={() => setAttorneyData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document} TP: {option.professionalCard}</div>
                                            ))
                                        :
                                            <span className="dropdown-message-item">Sin resultados  
                                                { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/usuarios/nuevo"}>, ¿crear?</a> : null}                        
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="task">Tarea</label>
                                    <input type="text" className="input-field" id="task" name="task" autoComplete="off" placeholder="Ingrese palabras clave" onChange={handleInputChange} value={form.task}></input>
                                </div>
                                <div  className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="taskStatus">Estado de la tarea</label>
                                    <select className="input-field" id="taskStatus" name="taskStatus" onChange={handleInputChange} value={form.taskStatus}>
                                        <option></option>
                                        {taskStatus.map( status => (
                                            <option key={status}>{status}</option>
                                        ))}
                                    </select>
                                </div>
                                <div  className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="visibility">Visibilidad</label>
                                    <select className="input-field" id="visibility" name="visibility" onChange={handleInputChange} value={form.visibility}>
                                        <option value="">Visibles</option>
                                        <option value="1">Ocultos</option>
                                        <option value="2">Ambos</option>
                                    </select>
                                </div>
                                <div className="w-100 d-flex justify-content-center m-2">
                                    <div className="d-flex search-button with-text justify-content-center align-items-center" onClick={searchFunction}>
                                        <span>Buscar</span>
                                        <BsSearch/>
                                    </div>
                                </div>
                                <div className="w-100 d-flex justify-content-center my-1">
                                    <span className="delete-search-text" onClick={deleteSearch}>
                                        Eliminar búsqueda
                                    </span>
                                </div>
                            </div>
                        }
                        <div className="d-flex justify-content-end">
                            <Link to={`${currentLink}/nueva`} className="primary-button">Añadir nueva tarea +</Link>
                        </div>
                    </>
                }
                <div className="w-100 d-flex justify-content-between my-4">
                    <span className='align-self-center'>{isSearched?'Resultados búsqueda':'Tareas'}: <b>{paginatorData.totalitems}</b></span>
                </div>
                <table className="list-table mb-4" style={{tableLayout: 'fixed', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    <thead>
                        <tr>
                            <th style={{width: '3%'}}>#</th>
                            <th style={{width: '9%'}}>Radicado</th>
                            <th style={{width: '25%'}}>Actividad&#47;Tarea</th>
                            <th style={{width: '14%'}}>Responsable</th>
                            <th style={{width: '11%'}}>Cumplimiento</th>
                            <th style={{width: '25%'}}>Avances</th>
                            <th style={{width: '8%'}}>Estado</th>
                            { user.userType === 'Administrador' &&
                                <th style={{width: '5%'}}></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((task, index) => (
                            <tr key={index}>
                                <td> <Link to={`/tareas/editar/${task._id}`} key={task._id}>{ (index+1) + skip }</Link> </td>
                                <td> <Link to={`/tareas/editar/${task._id}`} key={task._id}>{task.caseText}</Link> </td>
                                <td style={{width: '25%'}}> <Link to={`/tareas/editar/${task._id}`} key={task._id}>{task.task}</Link> </td>
                                <td style={{backgroundColor: task.backgroundColor}}>
                                    <Link to={`/tareas/editar/${task._id}`} key={task._id} style={{color: 'white'}}>
                                        {task.personInCharge.firstName} {task.personInCharge.lastName}
                                    </Link>
                                </td>
                                <td> <Link to={`/tareas/editar/${task._id}`} key={task._id}>{formatDate(task.date, 4)}</Link> </td>
                                <td style={{width: '25%'}}> <Link to={`/tareas/editar/${task._id}`} key={task._id}>{task.progress}</Link> </td>
                                <td> 
                                    <Link to={`/tareas/editar/${task._id}`} key={task._id}>
                                        {task.status} <br/>
                                        <b><i>{!task.visibility?'(Oculta)':''}</i></b>
                                    </Link> 
                                </td>
                                { user.userType === 'Administrador' &&
                                    <td>
                                        <BsFillTrashFill onClick={()=>handleOnClick(1,task)} className='trash-icon' />
                                        <BsFillEyeSlashFill onClick={()=>handleOnClick(2,task)} className='trash-icon' />
                                    </td>
                                }
                            </tr> 
                        ))}
                    </tbody>
                </table>
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0 &&
                    <Paginator 
                        skip={skip}
                        data={paginatorData}
                        setSkip={(n) => setSkip(n)}
                        setLoadData={(need) => setLoadData(need)}
                        queryParams={searchParams}
                        setQueryParams={(params) => setSearchParams(params)} />
                }
            </div>
        </div>
    );
}

export default TasksList;
  